module.exports = __webpack_public_path__ + "img/valentine_modal.d35f6ecd.jpg";